import { Country, Postcode } from '@dreryk/address-common-api';

import { commonTranslationKeys, FormContextValues } from '@dreryk/react-common';
import { PostcodeInput } from '@dreryk/react-components';

type PartialFormBean = {
   postcode: Postcode | null;
   country: Country;
};

type PostalCodeFieldProps = Pick<FormContextValues<PartialFormBean>, 'register' | 'watch'> & {
   readonly required?: boolean;
};

const PostalCodeField = (props: PostalCodeFieldProps): JSX.Element => {
   const selectedCountry = props.watch('country');

   return (
      <PostcodeInput
         controller={props.register('postcode', { required: props.required })}
         label={commonTranslationKeys.addressData.zipCode}
         countryIsoCode={selectedCountry.getIsoCode()}
         testId={'postcode'}
      />
   );
};

export { PostalCodeField };
